import { Button, CssBaseline, Container, Card, CardContent, Grid, CircularProgress, Alert } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Notification from '../utils/Notification';
import { FormProvider, RHFTextField } from '../components/hook-form';
import { OtpSchema } from '../utils/SchemaValidation';
import { BaseAPI } from '../utils/Api';
import { getItem, setItem } from '../utils/Helper';

const ReceiveOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const defaultValues = {
    otp: '',
  };

  const methods = useForm({
    resolver: yupResolver(OtpSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const body = {
      email: getItem(localStorage, 'e'),
      otp: data.otp,
    };

    await BaseAPI.post('/auth/verify-otp', body)
      .then((res) => {
        setItem(localStorage, 'at', res.data.data.token);
        setItem(localStorage, 'fn', res.data.data.f_name);
        setItem(localStorage, 'p', res.data.data.phone);
        setItem(localStorage, 'un', res.data.data.id.toString());

        if (state) {
          navigate(state);
        } else {
          navigate('/');
        }
      })
      .catch((err) => {
        console.log(err);
        Notification(err?.response?.data?.message, 'error');
      })
      .finally(() => {
        reset();
      });
  };

  return (
    <Container component='main' maxWidth='sm' sx={{ height: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
      <CssBaseline />
      <Grid container>
        <Grid item xs={12}>
          <Alert variant='outlined' severity='success'>
            An OTP has been sent to {getItem(localStorage, 'e')}
          </Alert>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <RHFTextField name='otp' label='Enter OTP' />
                <Button type='submit' fullWidth variant='contained' disableElevation color='primary' disabled={isSubmitting} sx={{ mt: 3 }}>
                  {isSubmitting ? <CircularProgress size={24} color='primary' /> : 'Verify OTP'}
                </Button>

                <Grid container mt={2}>
                  <Grid item xs>
                    <Button variant='text' color='primary' component={Link} to='/login'>
                      Login
                    </Button>
                  </Grid>
                </Grid>
              </FormProvider>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ReceiveOtp;
